import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

declare global {
  interface Window {
    __siteSettingsPrefetch?: Promise<{ maintenance_enabled?: boolean; maintenance_message?: string } | null>;
  }
}

export function useMaintenanceMode() {
  const { data, isLoading } = useQuery({
    queryKey: ["site-settings-maintenance"],
    queryFn: async () => {
      // Reuse the in-flight request started from index.html (breaks the critical request chain).
      if (typeof window !== "undefined" && window.__siteSettingsPrefetch) {
        const prefetched = await window.__siteSettingsPrefetch;
        // Consume once so subsequent refetches use the supabase client.
        window.__siteSettingsPrefetch = undefined;
        if (prefetched) return prefetched;
      }
      const { data, error } = await supabase
        .from("site_settings")
        .select("maintenance_enabled, maintenance_message")
        .eq("id", "main")
        .single();
      if (error) throw error;
      return data;
    },
    staleTime: 5 * 60_000,
    refetchInterval: 5 * 60_000,
  });

  return {
    isMaintenanceMode: data?.maintenance_enabled ?? false,
    maintenanceMessage: data?.maintenance_message ?? "Estamos realizando mejoras en la plataforma. Volveremos en breve.",
    isLoading,
  };
}
